import { render, staticRenderFns } from "./notification-table.vue?vue&type=template&id=9ff1f6f8&scoped=true&"
import script from "./notification-table.vue?vue&type=script&lang=js&"
export * from "./notification-table.vue?vue&type=script&lang=js&"
import style0 from "./notification-table.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./notification-table.vue?vue&type=style&index=1&id=9ff1f6f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff1f6f8",
  null
  
)

component.options.__file = "notification-table.vue"
export default component.exports